import { useQuickPostSpaceId } from "@circle-react/components/QuickPost/useQuickPostSpaceId";
import { getPostFormDefaults } from "@circle-react/components/QuickPostV3/data/getPostFormDefaults";
import type {
  SpaceIdInput,
  TiptapBody,
} from "@circle-react/components/QuickPostV3/data/types";
import { usePersistedDraft } from "@circle-react/components/QuickPostV3/data/usePersistedDraft";
import { QuickPostV3Form } from "@circle-react/components/QuickPostV3/Form";
import { CurrentPostContextProvider } from "@circle-react/contexts/currentPostContext";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

interface NewPostWrapperProps {
  onForceClose: () => void;
  onRequestClose: () => void;
  onSubmitSuccess?: () => void;
  shouldPersistDraft?: boolean;
  shouldSkipRedirectAfterSubmit?: boolean;
  spaceId?: SpaceIdInput;
  tiptapBodyForEditor?: TiptapBody;
  title?: string;
}

export const NewPostWrapper = ({
  onForceClose,
  onRequestClose,
  onSubmitSuccess,
  shouldPersistDraft,
  shouldSkipRedirectAfterSubmit,
  spaceId,
  tiptapBodyForEditor,
  title,
}: NewPostWrapperProps) => {
  const defaultSpaceId = useQuickPostSpaceId(spaceId);
  const persistedDraft = usePersistedDraft();
  const { currentUser } = usePunditUserContext();
  const { defaultValues, shouldShowTipTap } = getPostFormDefaults({
    currentUserId: currentUser?.id,
    defaultSpaceId,
    persistedDraft,
    tiptapBodyForEditor,
    title,
    variant: "create",
  });

  return (
    <CurrentPostContextProvider post={defaultValues}>
      <QuickPostV3Form
        defaultValues={defaultValues}
        onForceClose={onForceClose}
        onRequestClose={onRequestClose}
        onSubmitSuccess={onSubmitSuccess}
        shouldPersistDraft={shouldPersistDraft}
        shouldSkipRedirectAfterSubmit={shouldSkipRedirectAfterSubmit}
        shouldShowTipTap={shouldShowTipTap}
        variant="create"
      />
    </CurrentPostContextProvider>
  );
};
